import Model from './Model';

export default class extends Model {
  static data() {
    return {
      id: '',
      name: '',
    };
  }

  async findById(id) {
    let url = `species/families/${id}?` + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-families'
      )
    );
  }

  async get() {
    let url = 'species/families?' + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-families'
      )
    );
  }

  async save(family) {
    if (family.id) {
      let url = `species/families/${family.id}`;
      return this.patchPromise(url, family);
    }
    return this.postPromise(`species/families`, family);
  }

  async delete(id) {
    let url = `species/families/${id}`;
    return this.deletePromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'delete-family'
      )
    );
  }
}
